import siteMetadata from '../../config/site-metadata'

export const JohnDeereBrand = {
  '@context': 'http://schema.org/',
  '@type': 'Brand',
  'name': 'John Deere',
  'url': 'https://www.deere.com/en/',
}

export const JohnDeereOrganization = {
  '@context': 'http://schema.org/',
  '@type': 'Organization',
  'name': 'John Deere',
  'url': 'https://www.deere.com/en/',
}

export const StihlBrand = {
  '@context': 'http://schema.org/',
  '@type': 'Brand',
  'name': 'STIHL',
  'url': 'https://www.stihlusa.com/',
}

export const StihlOrganization = {
  '@context': 'http://schema.org/',
  '@type': 'Organization',
  'name': 'STIHL',
  'url': 'https://www.stihlusa.com/',
}

export const ManitouBrand = {
  '@context': 'http://schema.org/',
  '@type': 'Brand',
  'name': 'Manitou',
  'url': 'https://www.manitou.com/en-US',
}

export const ManitouOrganization = {
  '@context': 'http://schema.org/',
  '@type': 'Organization',
  'name': 'Manitou',
  'url': 'https://www.manitou.com/en-US',
}

export const organizationSchema = {
  '@context': 'http://schema.org/',
  '@type': 'Organization',
  'name': 'Hutson Inc',
  'legalName': 'Hutson, Inc.',
  'url': 'https://www.hutsoninc.com/',
  'logo': {
    '@type': 'ImageObject',
    'url': 'https://www.hutsoninc.com/hutson-logo-square.jpg',
    'width': '720px',
    'height': '720px',
  },
  'sameAs': [
    siteMetadata.facebookUrl,
    siteMetadata.instagramUrl,
    siteMetadata.linkedinUrl,
    siteMetadata.twitterUrl,
    siteMetadata.youtubeUrl,
  ],
  'contactPoint': [
    {
      '@type': 'ContactPoint',
      'telephone': '+1-866-488-7662',
      'contactType': 'customer service',
      'email': 'contactus@hutsoninc.com',
    },
  ],
  'brand': [
    {
      '@context': 'http://schema.org/',
      '@type': 'Organization',
      'name': 'Precision Ag',
      'url': 'https://www.hutsoninc.com/precision-ag/',
    },
    JohnDeereBrand,
    StihlBrand,
  ],
}
